/**
 * 统一的加载态。
 *
 * 🔴 **为什么单独一个文件**（本批实测被 `no-circular` 抓到）：
 * 它原先定义在 `shell/AppRoutes.tsx` 里，而各页面要 `import { Loading } from '../shell/AppRoutes.js'`
 * —— 于是形成 **`pages/* → shell/AppRoutes → pages/*` 的循环依赖**（4 条，架构检查直接报错）。
 * 循环依赖不会让构建失败（ESM 能处理），但会让**模块初始化顺序**变得不可推理：
 * 顶层 `const` 在环里的求值时机取决于谁先被 import —— 这类 bug 表现为"有时 undefined"，
 * 是最难查的一类。⇒ 抽成叶子模块，方向变成 `pages/* → ui/Loading`（单向）。
 */

import { Box, CircularProgress } from '@mui/material';

export function Loading({ py = 6 }: { py?: number }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py }}>
      <CircularProgress size={28} />
    </Box>
  );
}
